/**
 * @name index.js
 * @description Main entrypoint for vuex store.
 * @author Kelvin John Santos
 * @version 1.0
 * @since March 20, 2019
 */

import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

// Utils
import { createLogger } from "@sleek/customer-common-acquisition";
// Store Modules
import configModule from "./modules/config-module";
import userModule from "./modules/user-module";
import authModule from "./modules/auth";
import twoFactorAuthModule from "./modules/two-factor-auth-module";

Vue.use(Vuex);
let debug = false;

const vuexPersist = new VuexPersistence({
  strictMode: true, // This **MUST** be set to true
  storage: sessionStorage,
  // For the time being, it is only CA who uses this for Onboarding Flow
  filter: (mutation) => mutation.type.toLowerCase().includes("onboardingflow"),
  reducer: (state) => ({ onboardingFlowModule: state.onboardingFlowModule }),
});

const defaultPlugins = [vuexPersist.plugin];

export default new Vuex.Store({
  modules: {
    configModule,
    userModule,
    authModule,
    twoFactorAuthModule,
    // TODO: twofactor
  },
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
  },
  strict: debug,
  plugins: debug ? [createLogger(), ...defaultPlugins] : defaultPlugins,
});
